import GridList from 'modules/documents/components/GridList'
import FolderListItemSkeleton from 'modules/documents/components/GridList/Skeleton/ListItem'

interface Props {
  numberOfSkeletons: number
}

const FoldersSkeleton = ({ numberOfSkeletons }: Props) => {
  return (
    <GridList.List>
      {[...Array(numberOfSkeletons)].map((_, index) => (
        <FolderListItemSkeleton key={`folders-item-skeleton-${index}`} />
      ))}
    </GridList.List>
  )
}

export default FoldersSkeleton
